// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib__Array from "melange/array.js";
import * as Stdlib__Float from "melange/float.js";
import * as Stdlib__List from "melange/list.js";

function number(value) {
  const n = Js__Js_json.decodeNumber(value);
  if (n !== undefined) {
    if (Stdlib__Float.is_finite(n) && n >= 0) {
      return n;
    }
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_usage_response"
      });
  }
  throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
      MEL_EXN_ID: Mapre_wire__Json.Invalid,
      _1: "invalid_usage_response"
    });
}

function optional_number(value) {
  if (Caml_obj.caml_equal(value, null)) {
    return;
  } else {
    return number(value);
  }
}

function count(json, key) {
  const n = Mapre_wire__Json.integer(json, key);
  if (n < 0) {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_usage_response"
      });
  }
  return n;
}

function status(json, key) {
  const match = Mapre_wire__Json.string(json, key);
  switch (match) {
    case "pending" :
      return /* Pending */ 1;
    case "recorded" :
      return /* Recorded */ 0;
    case "unavailable" :
      return /* Unavailable */ 2;
    default:
      throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
          MEL_EXN_ID: Mapre_wire__Json.Invalid,
          _1: "invalid_usage_response"
        });
  }
}

function category(json, name) {
  const row = Mapre_wire__Json.get(json, name);
  const result_status = status(row, "status");
  const result_amount_status = status(row, "amount_status");
  const result_amount = optional_number(Mapre_wire__Json.get(row, "amount_microusd"));
  const result_recorded_amount = optional_number(Mapre_wire__Json.get(row, "recorded_amount_microusd"));
  const result_quantities = Stdlib__List.map((function (q) {
    return {
      unit: Mapre_wire__Json.string(q, "unit"),
      value: number(Mapre_wire__Json.get(q, "quantity"))
    };
  }), Stdlib__Array.to_list(Mapre_wire__Json.array(row, "quantities")));
  const result = {
    name,
    status: result_status,
    amount_status: result_amount_status,
    amount: result_amount,
    recorded_amount: result_recorded_amount,
    quantities: result_quantities
  };
  if (result_amount_status === /* Recorded */ 0 && result_amount === undefined) {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_usage_response"
      });
  }
  return result;
}

function decode(json) {
  const usage = Mapre_wire__Json.get(json, "usage");
  const seats = Mapre_wire__Json.get(json, "seats");
  const value = Js__Js_json.decodeBoolean(Mapre_wire__Json.get(usage, "complete"));
  let complete;
  if (value !== undefined) {
    complete = value;
  } else {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_usage_response"
      });
  }
  const total = optional_number(Mapre_wire__Json.get(usage, "totals_microusd"));
  if (complete !== (total !== undefined)) {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_usage_response"
      });
  }
  const value$1 = Mapre_wire__Json.get(json, "subscription");
  const subscription = Caml_obj.caml_equal(value$1, null) ? undefined : Mapre_wire__Json.string(value$1, "status");
  const partial_arg = Mapre_wire__Json.get(usage, "categories");
  const report_window_days = count(usage, "window_days");
  const report_categories = Stdlib__List.map((function (param) {
    return category(partial_arg, param);
  }), {
    hd: "compute",
    tl: {
      hd: "model",
      tl: {
        hd: "snapshot",
        tl: {
          hd: "proxy",
          tl: /* [] */ 0
        }
      }
    }
  });
  const report_pending = count(usage, "pending_runs");
  const report_unattributed = count(usage, "unattributed_runs");
  const report_exhausted = count(usage, "exhausted_runs");
  const report_seats_used = count(seats, "used");
  const report_seats_limit = optional_number(Mapre_wire__Json.get(seats, "limit"));
  const report = {
    window_days: report_window_days,
    categories: report_categories,
    total,
    complete,
    pending: report_pending,
    unattributed: report_unattributed,
    exhausted: report_exhausted,
    seats_used: report_seats_used,
    seats_limit: report_seats_limit,
    subscription
  };
  if (complete && (report_pending !== 0 || report_unattributed !== 0 || report_exhausted !== 0 || Stdlib__List.exists((function (c) {
      if (c.status !== /* Recorded */ 0) {
        return true;
      } else {
        return c.amount_status !== /* Recorded */ 0;
      }
    }), report_categories))) {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_usage_response"
      });
  }
  return report;
}

function update(t, json) {
  if (/* tag */ typeof json !== "object" && typeof json !== "function") {
    if (json === /* Loading */ 3) {
      return {
        report: t.report,
        loading: true,
        message: ""
      };
    } else {
      return t;
    }
  } else if (json.TAG === /* Loaded */ 0) {
    return {
      report: decode(json._0),
      loading: false,
      message: ""
    };
  } else {
    return {
      report: undefined,
      loading: false,
      message: json._0
    };
  }
}

const initial = {
  report: undefined,
  loading: true,
  message: ""
};

export {
  initial,
  category,
  update,
}
/* Mapre_wire__Json Not a pure module */
